module.exports = __webpack_public_path__ + "img/aus.e0fe977c.png";